<main class="main-home-secton">
  <div class="header p-relative">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="header-content">
            <h2>Tamil Nadu Startup Incubator Ecosystem</h2>
            <p>
              Tamil Nadu has built a thriving start-up ecosystem by supporting
              Incubators which has helped create a steady stream for new
              innovative ideas and startups. These incubators provide a vital
              starting point for entrepreneurs to learn about various aspects of
              startups and also help them in taking the first steps towards
              creating ventures. TamilNadu’s vibrant startup ecosystem has 102
              Incubators, which is the largest in the country.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="header-button">
      <button
        class="btn incubateeCss"
        (click)="viewIncubateesList()"
        style="color: #fff; background-color: #04919e; border-color: #ffffff"
      >
        View Incubatees List
      </button>
    </div>
  </div>
  <div class="container">
    <div class="FindIncubators">
      <h2 class="mt-5">Find Incubators Nearby</h2>

      <div class="filterIncubators">
        <div [formGroup]="searchForm">
          <div class="overall">
            <img
              class="new-eventimage"
              src="/assets/images/icon-img.png"
              alt=""
            />
            <div class="incubator-field">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Incubator Name <span class="text-danger"></span
                ></mat-label>
                <mat-select
                  formControlName="incubatorName"
                  (selectionChange)="selectIncubator($event.value)"
                  placeholder="Search Incubator Name"
                  #singleSelect
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="incubatorFilterCtrl"
                      placeholderLabel="Search Incubator Name"
                      noEntriesFoundLabel="Incubator not found"
                      appBlockCharsInput
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let list of incubatorListValue | async"
                    [value]="list.incubatorName"
                  >
                    {{ list.incubatorName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="incubartor-line">
              <img
                style="height: 75px"
                src="assets/images/Line 96.png"
                alt=""
              />
            </div>
            <div class="incubator-field">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Incubator District <span class="text-danger"></span
                ></mat-label>
                <mat-select
                  (selectionChange)="selectIncubator($event.value)"
                  formControlName="incubatorDistrict"
                  #DistrictSelect
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="incubatorDistrictFilterCtrl"
                      placeholderLabel="Search District"
                      noEntriesFoundLabel="District not found"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let list of incubatorDistrictListValue | async"
                    [value]="list.district"
                  >
                    {{ list.district }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="incubartor-line">
              <img
                style="height: 75px"
                src="assets/images/Line 96.png"
                alt=""
              />
            </div>
            <div class="incubator-field">
              <mat-form-field class="material-full-width" appearance="fill">
                <mat-label
                  >Focused Sector <span class="text-danger"></span
                ></mat-label>
                <input
                  (input)="selectIncubator($event.value)"
                  matInput
                  placeholder="Enter Focused Sector"
                  formControlName="incubatorFocusedSector"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mb-3">
      <button
        *ngIf="searchValue == true"
        mat-raised-button
        color="warn"
        (click)="clearBtn()"
      >
        Clear
      </button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="margin-set">
      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4"
          *ngIf="noData == false"
        >
          <div class="row">
            <div
              class="col-lg-4 col-md-6 col-sm-6 col-12"
              *ngFor="let list of searchList; let i = index"
            >
              <div class="events-div">
                <div class="events-img">
                  <div class="incu-card card">
                    <img
                      [src]="list.incubatorLogoFileName"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="event-titles text-center">
                  <h5 class="incubatorName">{{ list.incubatorName }}</h5>
                  <div class="event-footer total-incubated">
                    <div *ngIf="list.incubateesCount == 0">
                      <b>Total Startups Incubated : To Be Updated</b>
                    </div>
                    <div *ngIf="list.incubateesCount != 0">
                      <b
                        >Total Startups Incubated :
                        {{ list.incubateesCount }}</b
                      >
                    </div>
                  </div>
                  <div class="event-footer pt-3">
                    <div class="d-flex justify-content-center">
                      <div class="location-name-div">
                        <ion-icon name="location-outline"></ion-icon>
                        {{ list.incubatorDistrict }}
                      </div>
                    </div>
                  </div>

                  <div class="example-container">
                    <div
                      [@routeAnimations]="
                        o &&
                        o.activatedRouteData &&
                        o.activatedRouteData['animation']
                      "
                    >
                      <router-outlet #o="outlet"></router-outlet>
                    </div>
                  </div>
                  <div class="mt-2">
                    <button
                      class="incubatorBtn"
                      (click)="viewDetails(list.incubatorName)"
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-div text-center m-3" *ngIf="totalPages > 1">
            <button
              mat-mini-fab
              color="accent"
              class="set-page mr-2"
              [disabled]="currentPage == 1"
              (click)="paginatePartList('prev')"
            >
              <i class="fas fa-chevron-left"></i>
            </button>
            <button
              mat-mini-fab
              color="accent"
              class="set-page"
              [disabled]="currentPage == totalPages"
              (click)="paginatePartList('next')"
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
        <div class="footer-image" *ngIf="noData == true">
          <div class="text-center no-data-div">
            <img
              src="assets/images/startupTn-new-logo.png"
              class="img-fluid"
              alt=""
            />
            <h6>No Records Found</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
